/**
 * Look for the TCF consent macro ${GDPR_CONSENT_xx} where xx is an integer. Publishers may pass us a consent
 * string which we can then forward onto our creatives/trackers/whoever without having to call the on-page
 * TCF API, which is rather convenient.
 */
export const RE_GDPR = /\$\{GDPR\}/g;
export const RE_GDPR_CONSENT = /\$\{GDPR_CONSENT_\d+\}/g;
export const RE_COPPA = /\%\%TFCD\%\%/;

export const GDPR_PREFIX = 'eas.';
